module.exports = __webpack_public_path__ + "img/qr.31201bf0.png";